import axios from "axios";
import config from "../lib/config.js";
// import
import { Encryptdata, Decryptdata } from "../lib/encode_decode.js";

export const loginAdmin = async (payload) => {

  let data = { data: Encryptdata(payload) };
  console.log("adminlogin ", payload, {
    method: "POST",
    url: `${config.AdminAPI}/adminlogin`,
    data: data,
  });
  try {
    const resp = await axios({
      method: "POST",
      url: `${config.AdminAPI}/adminlogin`,
      data: data,
    });
    // resp.data = await Decryptdata(resp?.data)
    console.log("returned response", resp.data);

    if (resp.data.token) localStorage.setItem("token", resp.data.token);
    // let x = Decryptdata(resp.data);
    console.log("returnedxxxxxresponse", resp.data);

    return resp.data;
  } catch (err) {
    console.log("err", err);
  }
};
export const getarticle = async () => {
  try {
    var resp = await axios({
      method: "GET",
      url: `${config.AdminAPI}/getarticle`,
    });
    console.log("member resp", resp.data);
    return resp.data;
  } catch (err) {
    console.log("err in article list", err);
  }
};

export const updateTheBuildTime = async (data) => {
  const token = localStorage.getItem("token");
  console.log("data in api", data);
  const resp = await fetch(`${config.AdminAPI}/build_time`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`, // added token here
    },
    body: JSON.stringify({
      id: data.id,
      build_Time_in_min: data.buildTime,
      levelLimit: data.levelLimit,
      buildLocationType: data.buildLocationType
    }),
  });

  const result = await resp.json();
  console.log("result in api", result);
  return result; // optional: return the response if needed
};


export const updateCrewCost = async (data) => {
  try {
    let resp = await axios({
      method: "put",
      url: `${config.AdminAPI}/updateCrewCost`,
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    });
    // resp.data = await Decryptdata(resp?.data)
    return resp.data;
  } catch (err) {
    console.log("updateCrewCost_err", err);
  }
};

export const sendResetLink = async (payload) => {
  try {
    let data = { data: Encryptdata(payload) };
    let resp = await axios({
      method: "post",
      url: `${config.AdminAPI}/getForgotPasswordOTP`,
      data: data,
      headers: { "Content-Type": "application/json" },
    });
    resp.data = await Decryptdata(resp?.data)
    return resp.data;
  } catch (err) {
    const data = err.response?.data ? await Decryptdata(err.response.data) : { status: false, message: err.message };
    console.log("sendResetLink_err", err, data);
    return data;
  }
};

export const resetPassword = async (payload) => {
  try {
    console.log("payload in api", payload);
    let data = { data: Encryptdata(payload) };
    let resp = await axios({
      method: "put",
      url: `${config.AdminAPI}/getForgotPasswordOTP`,
      data: data,
      headers: { "Content-Type": "application/json" },
    });
    resp.data = await Decryptdata(resp?.data)
    return resp.data;
  } catch (err) {
    const data = err.response?.data ? await Decryptdata(err.response.data) : { status: false, message: err.message };
    console.log("resetPassword_err", err, data);
    return data;
  }
};